import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../services/Auth/AuthService';
import { CircularProgress, Box, Typography } from '@mui/material';

const SignoutCallback: React.FC = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const handledRef = useRef(false);

    useEffect(() => {
        if (handledRef.current) return;
        handledRef.current = true;

        const handleCallback = async () => {
            try {
                console.log('Completing signout...');
                const authService = await AuthService.theInstance();
                await authService.signoutRedirectCallback();
                navigate('/');
            } catch (err) {
                console.error('Signout callback error:', err);
                setError(err instanceof Error ? err.message : 'Signout failed');
            }
        };

        handleCallback();
    }, [navigate]);

    if (error) {
        return (
            <Box 
                display="flex" 
                flexDirection="column" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="100vh"
            >
                <Typography variant="h5" color="error" gutterBottom>
                    Signout Error
                </Typography>
                <Typography variant="body1">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            justifyContent="center" 
            alignItems="center" 
            minHeight="100vh"
        >
            <CircularProgress />
            <Typography variant="body1" sx={{ mt: 2 }}>
                Signing out...
            </Typography>
        </Box>
    );
};

export default SignoutCallback;
